import { type Thing } from '/@/common/things/types'
import { createModal } from '/@/core/elements/modal'

export interface KudosModalData {
  thing: Pick<Thing, 'id' | 'myKudos' | 'allKudos' | 'thingType'> | null
}

const { api, component } = createModal<KudosModalData>(
  'KudosModal',
  () => import('./KudosModal.vue'),
  {
    thing: null,
  },
)

export const useKudosModal = api
export default component
